<template>
    <v-flex>
        <v-card flat class="d-flex align-center mr-4 mt-4" style="width: fit-content">
            <div v-if="item" class="d-flex align-center pr-5">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-avatar class="ma-3" size="35" :color="color" v-on="on">
                        <span style="cursor: default"
                              class="white--text body-2 font-weight-bold">{{ item.initials }}</span>
                        </v-avatar>
                    </template>
                    <span>{{ item.usermail }}</span>
                </v-tooltip>
                <div class="textContainer d-flex">
                    <div>{{ item.name }} bearbeitet grade <span
                        :style="{borderBottom: '1px solid '+color, fontWeight:500}">{{
                            item.site
                        }}</span></div>
                </div>
            </div>
            <div v-else class="d-flex align-center">
                <v-avatar class="ma-3 mr-4" size="35" :color="random(colors)">
                    <v-icon color="white">
                        {{ random(icons) }}
                    </v-icon>
                </v-avatar>
                <div class="textContainer d-flex" style="min-width:340px">
                    <div v-if="joke" class="d-flex flex-column my-4 pr-2">
                        <v-chip class="mb-2 font-weight-bold" dark label small style="width: min-content"
                                color="blue-grey lighten-2">
                            {{ "nichts los hier... Kennst du den schon? :D".toUpperCase() }}
                        </v-chip>
                        <div style="position:absolute; top:8px; right:0;">
                            <TooltipIcon tooltip="Neuen Witz laden" @click="loadJoke">mdi-refresh</TooltipIcon>
                        </div>

                        <!-- local file -->
                        <div class="pr-3" v-if="jokeSrc === 'local'">{{ joke }}</div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-flex>
</template>

<script>
import TooltipIcon from "./TooltipIcon";
import {jokes} from "@/scripts/jokes";

export default {
    name: "AvatarCard",
    components: {TooltipIcon},
    props: ['item', 'index'],
    data: () => {
        return {
            //colors: [ '#d70364', '#752b77', 'deep-purple accent-2', 'indigo darken-1', '#00b6ed', 'teal', 'orange', 'deep-orange accent-2', 'blue-grey lighten-1']
            colors: ['#00b6ed', '#d70364', '#832d85', '#009688', '#FF6E40', '#7C4DFF', '#FF9800', '#3949AB'],
            icons: ['mdi-cupcake', 'mdi-corn', 'mdi-death-star', 'mdi-duck', 'mdi-fish', 'mdi-flower',
                'mdi-google-downasaur', 'mdi-ice-cream', 'mdi-incognito', 'mdi-jellyfish', 'mdi-noodles',
                'mdi-one-up', 'mdi-pac-man'],
            joke: null,
            jokeSrc: 'local',
        }
    },
    mounted() {
        if (this.item === null) {
            this.loadJoke();
        }
    },
    computed: {
        color() {
            if (this.index !== "undefined") {
                if (this.index > this.colors.length - 1) {
                    return this.colors[this.index % this.colors.length];
                } else {
                    return this.colors[this.index];
                }
            } else {
                return this.colors[Math.floor(Math.random() * this.colors.length)];
            }
        },
    },
    methods: {
        random(array) {
            return array[Math.floor(Math.random() * array.length)];
        },
        loadJoke() {
						this.joke = jokes[Math.floor(Math.random() * jokes.length)];
        },
    }
}
</script>

<style lang="scss" scoped>
.textContainer div:not(:last-child) {
    margin-right: 5px;
}

.jokeHeader {

}
</style>